{
  "verified": "Перевірено",
  "iv_status": {
    "verified": "Перевірено",
    "pending": "На розгляді",
    "attention": "Увага!"
  },
  "zoom_in": "Збільшити",
  "zoom_out": "Зменшити",
  "rotate": "Поворот",
  "close": "Закрити",
  "esc_to_close": "Натисніть ESC, щоб закрити",
  "play": "Грай.",
  "pause": "Пауза.",
  "mute": "Вимкнути звук.",
  "unmute": "Увімкнути звук.",
  "enter_full_screen": "Увімкнути на весь екран",
  "exit_full_screen": "Вийти на весь екран",
  "video_not_supported": "Ваш браузер не підтримує тег video.",
  "skip_forward": "Перемотати вперед",
  "skip_backward": "Пропустити назад",
  "loading": "Завантаження",
  "loading_video": "Завантаження відео...",
  "loading_data_description": "Зачекайте, будь ласка, поки ми завантажимо ваші дані. Це не займе багато часу.",
  "no_results": "Немає результатів",
  "nothing_found": "Нічого не знайдено.",
  "save_changes": "Зберегти зміни",
  "saved_exclamation": "Врятовано!",
  "saving": "Заощадження",
  "validating": "Перевірка",
  "error": "Помилка.",
  "optional": "Необов'язково",
  "search_property": "Пошук нерухомості",
  "reset_search": "Скинути пошук",
  "no_items_to_show": "Немає товарів для показу",
  "showing_range_of_total_items": "Показати {{range}} з {{total}} предметів",
  "rows_per_page": "Рядки на сторінці",
  "page_of_pages": "Сторінка __ВЛАСНИКА_0__ у __ВЛАСНИКА_1__",
  "go_to_first_page": "Перейти на першу сторінку",
  "go_to_previous_page": "Перейти на попередню сторінку",
  "go_to_next_page": "Перейти на наступну сторінку",
  "go_to_last_page": "Перейти на попередню сторінку",
  "sort_in_asc": "Сортування за зростанням",
  "sort_in_desc": "Сортування за спаданням",
  "sort_a_z": "Сортування A → Z",
  "sort_z_a": "Сортування Z → A",
  "clear_sorting": "Чітке сортування",
  "reach_us_at_email": "Зверніться до служби підтримки за адресою support@chekin.com",
  "please_wait": "Будь ласка, зачекайте.",
  "feature_coming_soon": "Незабаром",
  "feature_coming_soon_description": "Ця функція наразі знаходиться в розробці і буде доступна найближчим часом. Слідкуйте за оновленнями!",
  "download_all": "Завантажити все",
  "entry_forms": "Заявки на участь у конкурсі",
  "tutorial": "Навчальний посібник",
  "liveness_video": "Відео в прямому ефірі",
  "beta": "Бета",
  "reviews": "Відгуки",
  "learn_more": "Дізнайтеся більше",
  "this_cannot_be_reverted": "Це не можна повернути назад",
  "delete": "Видалити",
  "cancel": "Скасувати",
  "you_have_made_changes": "Ви внесли зміни",
  "would_you_like_to_save_them": "Хочете їх врятувати?",
  "save": "Зберегти",
  "dont_save": "Не заощаджуй",
  "copied_exclamation": "Зрозумів!",
  "search_placeholder": "Обшук...",
  "type_to_search": "Введіть для пошуку...",
  "loading_more": "Завантаження...",
  "no_options": "Без варіантів",
  "select_option": "Виберіть варіант",
  "clear_all": "Зачистити все.",
  "remove_item": "Видалити {{label}}",
  "upload_file": "Завантажити файл",
  "download_attachment": "Завантажте вкладення",
  "remove_file": "Видалити файл",
  "open_calendar": "Відкритий календар",
  "clear_dates": "Чіткі дати",
  "select_dates": "Виберіть дати",
  "pick_date_range": "Виберіть діапазон дат",
  "from": "Від",
  "to": "До",
  "pick_month": "Вибери місяць.",
  "pick_date": "Виберіть дату.",
  "month": "Місяць",
  "day": "День",
  "year": "Рік",
  "done": "Зроблено.",
  "wrong_period_of_dates": "Обраний період є недійсним",
  "date_range_max_days_error_one": "Термін не може перевищувати {{count}} днів",
  "date_range_max_days_error_other": "Діапазон не може перевищувати {{count}} днів",
  "date_range_min_days_error_one": "Термін дії повинен бути не менше {{count}} днів",
  "date_range_min_days_error_other": "Термін дії повинен бути не менше {{count}} днів",
  "past_dates": "Дата не може бути раніше {{minDate}}.",
  "future_dates": "Дата не може бути після {{maxDate}}.",
  "signature_placeholder_text": "Підпишіться в цьому полі.<br/> Використовуйте палець.<br/> Торкніться, щоб почати.",
  "open_devices_camera": "Відкрийте камеру пристрою",
  "place_document_inside_frame": "Помістіть документ у фрейм",
  "close_other_application_that_may_be_using_your_camera": "Закрийте інші програми, які можуть використовувати камеру",
  "if_you_use_external_camera_disconnect_and_reconnect": "Якщо ви використовуєте зовнішню камеру, від'єднайте та знову під'єднайте її",
  "close_the_browser_re_open_it": "Закрийте браузер і відкрийте його знову",
  "camera_errors": {
    "experiencing_camera_issues": "Виникають проблеми з камерою?",
    "chekin_cant_use_your_camera": "Чекін не може користуватися твоєю камерою",
    "please_try_a_different_browser": "Ваша камера не працює в цьому браузері. Будь ласка, спробуйте відкрити посилання в іншому браузері.",
    "permissions_denied": "У дозволі відмовлено",
    "camera_permissions_denied": "Камера не відкривається? Переконайтеся, що браузер має дозвіл на використання камери.",
    "no_camera_device_found": "Пристрій не знайдено. Будь ласка, підключіть камеру.",
    "constraints_camera_error": "Обмеження не можуть бути задоволені наявними пристроями.",
    "safari_camera_error": "Safari не міг задовольнити вимоги до камери",
    "try_chrome_or_firefox": "Будь ласка, спробуйте Chrome або Firefox"
  },
  "clear": "Чисто",
  "show_less": "Показати менше",
  "show_more": "Показати більше",
  "tap_here_to_sign": "Натисніть тут, щоб підписати",
  "click_here_to_sign": "Натисніть тут, щоб підписати",
  "prefix": "Префікс",
  "prefix_required": "Префікс обов'язковий",
  "reset": "Перезавантаження",
  "show_password": "Показати пароль",
  "hide_password": "Приховати пароль",
  "increment": "Приріст",
  "decrement": "Декрет",
  "create_option": "Створіть \"{{input}}\"",
  "year_out_of_range": "Рік повинен бути між {{min}} та {{max}}.",
  "clear_date": "Очистити дату",
  "select_date": "Виберіть дату",
  "draw_signature_here": "Поставте тут свій підпис",
  "signature_hint": "Користуйтеся мишкою або пальцем",
  "clear_signature": "Чіткий підпис",
  "draw_signature_here_mobile": "Намалюйте свій підпис",
  "signature_hint_mobile": "Використовуйте палець",
  "camera_access_needed": "Потрібен доступ до камери",
  "camera_access_needed_text": "Надайте камері доступ для зйомки фотографії. Якщо доступ заблоковано, увімкніть камеру в налаштуваннях браузера, а потім спробуйте ще раз.",
  "dialog": "Діалог"
}
